module.exports = __webpack_public_path__ + "static/media/serenity.f5494ed2.jpeg";